// extracted by mini-css-extract-plugin
export default {"header":"Title_header__+kgRy","titleGreen":"Title_titleGreen__pk+SV"};